import { aranySzoveg, percSzoveg, valtozasPerc, valtozasPont, type Valtozas } from './valtozas.ts';
import type { ElemzesMutatok } from './tipusok.ts';

function Valtozasjel({ v }: { v: Valtozas | null }) {
  if (!v) return null;
  // Smaragd = javulás, arany = romlás; a változatlan halk. A szöveg önmagában is érthető (nem csak szín).
  const szin = v.irany === 'javul' ? 'text-kiemelt' : v.irany === 'romlik' ? 'text-masodlagos' : 'text-szoveg-halk';
  return <small className={`mt-1.5 block text-xs ${szin}`}>{v.szoveg}<span className="sr-only"> az előző időszakhoz képest</span></small>;
}

function Mutato({ ertek, cimke, reszlet, valtozas }: { ertek: string; cimke: string; reszlet?: string; valtozas: Valtozas | null }) {
  return (
    <div className="border-t border-vonal px-0 py-3.5 first:border-t-0 nth-2:border-t-0 md:border-t-0 md:border-l md:px-5 md:py-[18px] md:first:border-l-0 md:first:pl-0">
      <b className="szam-nagy block text-[26px] md:text-[30px]">{ertek}</b>
      <span className="mt-1 block text-[13px] text-szoveg-halk">{cimke}</span>
      {reszlet && <small className="mt-1.5 block text-xs text-szoveg-halk">{reszlet}</small>}
      <Valtozasjel v={valtozas} />
    </div>
  );
}

/** A mutatósor: öt szám az előző azonos hosszú időszakhoz mért változással. */
export default function Mutatosor({ most, elozo }: { most: ElemzesMutatok; elozo: ElemzesMutatok }) {
  return (
    <div role="group" aria-label="Fő mutatók" className="mt-6 grid grid-cols-2 border-y border-vonal md:grid-cols-5">
      <Mutato ertek={aranySzoveg(most.megerositesi_arany)} cimke="megerősítette az SMS-kódot" reszlet={`${most.inditasok} indításból`} valtozas={valtozasPont(most.megerositesi_arany, elozo.megerositesi_arany)} />
      <Mutato ertek={percSzoveg(most.reakcio_median_perc)} cimke="medián reakcióidő" valtozas={valtozasPerc(most.reakcio_median_perc, elozo.reakcio_median_perc)} />
      <Mutato ertek={aranySzoveg(most.hataridon_belul_arany)} cimke="visszahívva a határidőn belül" reszlet="az iroda saját visszahívási határideje szerint" valtozas={valtozasPont(most.hataridon_belul_arany, elozo.hataridon_belul_arany)} />
      <Mutato ertek={aranySzoveg(most.szemle_arany)} cimke="szemle a leadekből" valtozas={valtozasPont(most.szemle_arany, elozo.szemle_arany)} />
      <Mutato ertek={aranySzoveg(most.megbizas_arany)} cimke="megbízás a leadekből" valtozas={valtozasPont(most.megbizas_arany, elozo.megbizas_arany)} />
    </div>
  );
}
